import { TermsOfUseUserStatus } from "src/share/types/termsOfUse";

export const shouldShowTermsOfUse = (termsOfUseStatus: TermsOfUseUserStatus): boolean => {
  const { Initial, ExpiredUser } = TermsOfUseUserStatus
  return termsOfUseStatus === ExpiredUser || termsOfUseStatus === Initial
}